import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DialogHelper, ExceptionHelper, UserStorage } from './../../../../helper';

import { CustomerDetailService } from './customer-detail.service';
import { CustomerUpdateStatusService } from './customer-update-status.service';
import { CustomerSiteSummaryService } from './customer-site-summary.service';
import { CustomerResetPasswordService } from './customer-reset-password.service';
import { IsActive } from './../../../../model';

import * as $ from 'jquery';

@Component({
  selector: 'app-customer-detail',
  templateUrl: './customer-detail.component.html',
  styleUrls: ['./customer-detail.component.css'],
})
export class CustomerDetailComponent implements OnInit {

  customerId = '';
  customer: any;

  sites: any[];
  dataTable: any;

  isReset = false;

  constructor(
    private userStorage: UserStorage,
    private router: Router,
    private route: ActivatedRoute,
    private translate: TranslateService,
    private dialog: DialogHelper,
    private exception: ExceptionHelper,
    private customerDetailService: CustomerDetailService,
    private customerUpdateStatusService: CustomerUpdateStatusService,
    private customerSiteSummaryService: CustomerSiteSummaryService,
    private customerResetPasswordService: CustomerResetPasswordService,
    private chRef: ChangeDetectorRef,
  ) {
    this.route.params.subscribe(params => { this.customerId = params['id']; });
    this.translate.setDefaultLang('en-us');
  }

  ngOnInit() {

    this.customerDetailService.getDetail(this.customerId).subscribe((data) => {
      this.customer = data;
      this.chRef.detectChanges();
      this.customerSiteSummaryService.getSummary(this.customerId, IsActive.active).subscribe((data) => {
        if ($.fn.dataTable.isDataTable('#siteDataTables')) { $('#siteDataTables').DataTable().destroy(); }

        this.sites = data.siteListModel;
        this.chRef.detectChanges();

        const table: any = $('#siteDataTables');
        this.dataTable = table.DataTable();

      },
        error => {
          this.exception.showError(error, 'showDanModalBtn');
        });

    },
      error => {
        this.customer = {};
        this.chRef.detectChanges();
        $('.card').hide();
        this.exception.showError(error, 'showDanModalBtn');
      }
    );


  }

  errorClose() {
    this.router.navigate(['/home/customers']);
  }

  activate() {
    if (this.customer.isActive === 0) {
      this.updateStatus();
    } else {
      this.exception.showError(null, 'showDanModalBtn');
    }

  }

  deactivate() {
    if (this.customer.isActive === 1) {
      this.updateStatus();
    } else {
      this.exception.showError(null, 'showDanModalBtn');
    }

  }

  updateStatus() {
    this.customerUpdateStatusService.update(this.customerId).subscribe(data => {
      this.isReset = false;
      this.dialog.showModal('showSucModalBtn');
      this.customer = data;
      this.chRef.detectChanges();
    },
      error => {
        this.exception.showError(error, 'showDanModalBtn');
      });

  }

  resetPassword() {
    this.customerResetPasswordService.resetPassword(this.customerId).subscribe(data => {

      this.isReset = true;
      this.dialog.showModal('showSucModalBtn');

    },
      error => {
        this.exception.showError(error, 'showDanModalBtn');
      });

  }

  public toSummary(): void {
    const summary = $('#summary').val();
    switch (summary) {
      case 'job':
        this.router.navigate(['/home/job/summary/' + this.customerId]);
        break;

      case 'pm':
        this.router.navigate(['/home/preventive-maintenance/summary/' + this.customerId]);
        break;

      case 'ecall':
        this.router.navigate(['/home/e-call/summary/' + this.customerId]);
        break;

      case 'service':
        this.router.navigate(['/home/service/summary/' + this.customerId]);
        break;

      case 'equipment':
        this.router.navigate(['/home/equipment/summary-by-customer/' + this.customerId]);
        break;

      default:
        break;
    }
  }

  public add(): void {
    const add = $('#add').val();
    switch (add) {
      case 'site':
        this.router.navigate(['/home/site/add/' + this.customerId]);
        break;

      case 'job':
        this.router.navigate(['/home/job/add/form/' + this.customerId]);
        break;

      case 'ecall':
        this.router.navigate(['/home/e-call/add/' + this.customerId]);
        break;

      case 'service':
        this.router.navigate(['/home/service/add/cu/' + this.customerId]);
        break;

      default:
        break;
    }
  }


}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/customer/customer-detail/customer-detail.component.ts